// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDuplicateClaimDto
 */
export interface IDuplicateClaimDto {
    /**
     * 
     * @type {number}
     * @memberof IDuplicateClaimDto
     */
    duplicate_claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDuplicateClaimDto
     */
    claim_status_type?: IDuplicateClaimDtoClaimStatusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDuplicateClaimDtoClaimStatusTypeEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IDuplicateClaimDto interface.
 */
export function instanceOfIDuplicateClaimDto(value: object): value is IDuplicateClaimDto {
    return true;
}

export function IDuplicateClaimDtoFromJSON(json: any): IDuplicateClaimDto {
    return IDuplicateClaimDtoFromJSONTyped(json, false);
}

export function IDuplicateClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDuplicateClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'duplicate_claim_id': json['duplicate_claim_id'] == null ? undefined : json['duplicate_claim_id'],
        'claim_status_type': json['claim_status_type'] == null ? undefined : json['claim_status_type'],
    };
}

export function IDuplicateClaimDtoToJSON(json: any): IDuplicateClaimDto {
    return IDuplicateClaimDtoToJSONTyped(json, false);
}

export function IDuplicateClaimDtoToJSONTyped(value?: IDuplicateClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duplicate_claim_id': value['duplicate_claim_id'],
        'claim_status_type': value['claim_status_type'],
    };
}

